import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';
import { selectUserPreferences } from '@/redux/selectors/authSelectors';
import { Box, Grid } from '@mui/material';
import { buildGraphsOrderDefault, defaultGraphs, graphDirectory } from './DefaultGraphs';
import { useConfigValue } from '../_hooks/useConfigValue';
import { baseGraphList, graphList } from '@/redux/selectors/configSelectors';
import { useMemo } from 'react';

type SkeletonizedProp = {
  types: string[];
};

const Skeletonized = ({ types }: SkeletonizedProp) => {
  return (
    <Grid item xs={12} container spacing={2}>
      {types.map((type) =>
        type === 'status-cards' ? (
          <StatusCardsGrid key={`skeleton-${type}`} item xs={12 / types.length}>
            {graphDirectory[type]?.render()}
          </StatusCardsGrid>
        ) : (
          <Grid key={type} item xs={12 / types.length}>
            {graphDirectory[type]?.render()}
          </Grid>
        )
      )}
    </Grid>
  );
};

const DashboardSkeleton = () => {
  const canCustomizeDashboard = useConfigValue(['dashboardConfig', 'customizeDashboard']);
  const configGraphList = useConfigValue(['dashboardConfig', 'graphList']) || defaultGraphs;
  const allGraphs = baseGraphList.concat(configGraphList);
  const prefs = useAppSelector(selectUserPreferences);
  const graphIdsMatch = useMemo(() => {
    return JSON.stringify(prefs?.dashboard?.list.map((graph: { id: string; }) => graph.id).sort()) === JSON.stringify(graphList.map((graph) => graph.id).sort());
  }, [prefs, graphList]);
  const defaultOrder = useMemo(() => {
    return buildGraphsOrderDefault(graphIdsMatch ? prefs?.dashboard?.list : allGraphs);
  }, [prefs, graphIdsMatch, allGraphs]);
  const orderToDisplay = canCustomizeDashboard && graphIdsMatch ? prefs?.dashboard?.order || defaultOrder : defaultOrder;

  return (
    <Box>
      <Wrapper container spacing={2} sx={{ height: '100%' }}>
        {orderToDisplay.map((list: string[], index: number) => (
          <Skeletonized key={index} types={list} />
        ))}
      </Wrapper>
    </Box>
  );
};

const Wrapper = styled(Grid)`
  flex-direction: column;
  flex-wrap: nowrap;
`;

const StatusCardsGrid = styled(Grid)`
  .MuiGrid-root {
    margin: 0;
  }
`;

export default DashboardSkeleton;
